import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import theme from './theme'
import user from './user'
import lawyers from './lawyers'
import alertDialog from './alertDialog'
import loader from './loader'
import categories from './categories'
import offers from './offers'
import customerType from './customerType'
import barreaux from './barreaux'
import languages from './languages'
import competences from './competences'
import experience from './experience'
import feesMode from './feesMode'
import settings from './settings'
import suggestions from './suggestions'
import callPartner from './callPartner'
import searchLawyer from './searchLawyer'
import payment from './payment'

const combineReducers = (reducers) => (state = {}, action) =>
  Object.keys(reducers).reduce((accumulator, key) => {
    accumulator[key] = reducers[key](state[key], action)

    return accumulator
  }, {})

export default combineReducers({
  categories,
  customerType,
  theme,
  user,
  alertDialog,
  loader,
  offers,
  barreaux,
  languages,
  competences,
  experience,
  feesMode,
  settings,
  suggestions,
  callPartner,
  searchLawyer: persistReducer(
    {
      key: 'searchLawyer', // key for localStorage key, will be: "persist:form"
      storage,
      debug: false,
    },
    searchLawyer
  ),
  lawyers,
  payment,
})
